module.exports = __webpack_public_path__ + "static/media/restaurant.fa503915.jpg";